import type { Option } from '@comparit/core';
import { Geschlecht } from '../../../interfaces';

export const geschlechtOptions: Option<Geschlecht>[] = [
  { label: 'Männlich', value: Geschlecht.Maennlich },
  { label: 'Weiblich', value: Geschlecht.Weiblich },
  { label: 'Divers', value: Geschlecht.Divers },
];
